import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL 
    ? `${process.env.REACT_APP_API_URL}/api`
    : "http://localhost:8080/api",
});

// Add token to every request
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const getMe = () => API.get("/me");
export const getJobs = (config) => API.get("/jobs", config);
export const createJob = (job) => API.post("/jobs", job);
export const updateJob = (id, job) => API.put(`/jobs/${id}`, job);
export const deleteJob = (id) => API.delete(`/jobs/${id}`);

export default API;